import React, { useEffect, useState } from "react";
import { InventoryApiClient } from "./InventoryClient";
import { Link } from "react-router-dom";
import moment from "moment";
import {
  TableList,
  ColumnsDefinition,
} from "../../common/components/TableList";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";

export const inventoryClient: InventoryApiClient = new InventoryApiClient();

const onEdit = (id: number) => {
  window.open("/LostUnits/Edit/" + id, "_self");
};

const dateFormat: string = "YYYY-MM-DD";

const columnsDefinition: ColumnsDefinition = {
  columns: [
    { heading: "DSKU", width: 12, field: "dsku" },
    { heading: "Lost Quantity", width: 8, field: "lostQty" },
    { heading: "Found Quantity", width: 8, field: "foundQty" },
    { heading: "Reimbursed", width: 8, field: "reimbursedAmount" },
    { heading: "Notes", width: 10, field: "notes" },
    { heading: "Warehouse", width: 9, field: "warehouseId" },
    { heading: "ShippingPlan", width: 10, field: "shippingPlanId" },
    { heading: "FC Asn", width: 10, field: "fcAsnId" },
    { heading: "Seller", width: 15, field: "sellerid" },
    { heading: "Reporter", width: 10, field: "reportedBy" },
    { heading: "Asana", width: 8, field: "asanaTicket", urlBuilder: "${link}" },
    {
      heading: "Zendesk",
      width: 8,
      field: "zendeskTicket",
      urlBuilder:
        "https://flexport-fulfillment.zendesk.com/agent/tickets/${link}",
    },
    //    { heading: "Reason", width: 5, field: "reason" },
    {
      heading: "Created On",
      width: 7,
      field: "created",
      transform: (date: string) => moment(date).format(dateFormat),
    },
    //    { heading: "Updated On", width: 10, field: "updated", transform: (date: string) => (moment(date)).format(dateFormat)   },
    { heading: "Edit", width: 10, field: "id", action: onEdit },
  ],
};

export const LostUnitsList: React.FC = () => {
  const [data, setData] = useState({ records: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize: number = parseInt(process.env.PAGE_SIZE || "50", 10);
  const [totalPages, setTotalPages] = useState(0);
  const [applyFilter, setApplyFilter] = useState(false);
  const [fetchResults, setFetchResults] = useState(false);
  const [dskuState, setDskuState] = useState(undefined);
  const [shippingPlanIdState, setShippingPlanIdState] = useState(undefined);
  const [alertMessage, setAlertMessage] = useState("");

  useEffect(() => {
    inventoryClient
      .filterLostUnits(
        currentPage,
        pageSize,
        applyFilter ? dskuState : undefined,
        applyFilter ? shippingPlanIdState : undefined
      )
      .then((data) => {
        if (data.totalPages != 0) {
          setData({ records: data.lostUnitsTrackerEntries as any });
          setTotalPages(data.totalPages);
        } else {
          setAlertMessage(
            "Could not find any results for the applied filter dsku = " +
              dskuState +
              " and shippingPlanId = " +
              shippingPlanIdState
          );
        }
      })
      .catch((error) => {
        setAlertMessage(
          "Error occurred while fetching the results. Please contact warehouse-eng-support to resolve the issue: " +
            error
        );
      });
  }, [currentPage, fetchResults, pageSize]);

  const handlePageClick = (event: any) => {
    setCurrentPage(event.selected + 1);
  };

  const handleApplyFiltersClick = (event: any) => {
    event.preventDefault();
    clearStateVariablesOnApplyAndClearFilters();
    setApplyFilter(true);
    setFetchResults(!fetchResults);
  };

  const handleClearAllFiltersClick = (event: any) => {
    event.preventDefault();
    Array.from(document.querySelectorAll("input")).forEach(
      (input) => (input.value = "")
    );
    clearStateVariablesOnApplyAndClearFilters();
    setDskuState(undefined);

    setShippingPlanIdState(undefined);
    setApplyFilter(false);
    setFetchResults(!fetchResults);
  };

  const handleDSKUChange = (event: any) => {
    setDskuState(
      event.target.value?.trim() === "" ? undefined : event.target.value
    );
  };

  const handleShippingPlanIdChange = (event: any) => {
    setShippingPlanIdState(
      event.target.value?.trim() === "" ? undefined : event.target.value
    );
  };

  const clearStateVariablesOnApplyAndClearFilters = () => {
    setCurrentPage(1);
    setAlertMessage("");
    setData({ records: [] });
    setTotalPages(0);
  };

  const clearAlertMessage = () => {
    setAlertMessage("");
  };

  return (
    <div className="container" style={{ height: "90vh" }}>
      <div>
        <Dialog
          open={alertMessage != ""}
          onClose={setAlertMessage}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {alertMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <button onClick={clearAlertMessage}>Ok</button>
          </DialogActions>
        </Dialog>
      </div>
      <p>
        <Link to="../LostUnits/Create">Create New Lost Unit Record</Link>
      </p>
      <div>
        <form>
          <label>
            DSKU:
            <input type="text" value={dskuState} onChange={handleDSKUChange} />
          </label>
          &nbsp;&nbsp;
          <label>
            Shipping Plan Id:
            <input
              type="text"
              value={shippingPlanIdState}
              onChange={handleShippingPlanIdChange}
            />
          </label>
          &nbsp;&nbsp;
          <input
            type="submit"
            onClick={handleApplyFiltersClick}
            value="Apply filters"
          />
          &nbsp;&nbsp;
          <input
            type="submit"
            onClick={handleClearAllFiltersClick}
            value="Clear all filters"
          />
        </form>
      </div>
      <br />
      <TableList
        columns={columnsDefinition}
        data={data.records as []}
        enablePagination={true}
        selectedPageIndex={currentPage}
        totalPages={totalPages}
        handlePageClick={handlePageClick}
      />
    </div>
  );
};
